/*!
 *
 *	top-main.js
 *
 */

var duration = 5000;
var scale = 0.25;
var frame = 10;

var $main = $('#TopMain');
var $item = $main.find('.tp-Main_Image_Item');
var $loading = $main.find('.tp-Main_Loading');
var $active, active = 0;
var len = $item.length;

var imgLoad = function(src){
	var d = new $.Deferred;
	var $img = $('<img />');
	$img.attr('src', src).on('load', function(){
		d.resolve();
	});
	return d.promise();
};

var load = function(){
	var _len = len;
	$item.each(function(){
		var src = $(this).children('img').attr('src');
		var promise = imgLoad(src);
		$(this).children('img').hide(0);
		$(this).css('background-image', 'url(' + src + ')');
		promise.done(function(){
			if( --_len > 0 ) return false;
			build();
		});
	});
};

var build = function(){
	var _len = len;
	$item.each(function(i){
		$(this).css('z-index', _len - i);
		if( i === active ){
			$active = $(this);
		};
	});
	show();
};

var show = function(){
	$loading.fadeOut(1000, function(){
		$(this).remove();
		play();
	});
};

var play = function(){
	var count = duration / frame;
	var span = scale / count;
	var _scale = 1 + span;
	var max = count;
	for( var i=0; i<count; i++ ){
		setTimeout(function(){
			$active.css({
				x: '-50%',
				scale: _scale
			});
			_scale += span;

			if( --max > 0 ) return false;
			reset();
		}, i * frame);
	};
};

var reset = function(){
	$active.fadeOut(1000, function(){
		active++;
		if( active == len ){
			active = 0;
		};
		var next = active + 1;
		if( next == len ){
			next = 0;
		};
		$active.show(0).css({
			x: '-50%',
			scale: 1
		});
		$item.each(function(i){
			if( i === active ){
				$active = $(this);
				$(this).css('z-index', len);
			}else if( i === next ){
				$(this).css('z-index', len - 1);
			}else {
				$(this).css('z-index', 1);
			};
		});
		play();
	});
};

module.exports = function(){
	if( $main.length ){
		setTimeout(function(){
			load();
		}, 2000);
	};
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/top-main.js
// module id = 20
// module chunks = 0